import { useMutation, useQuery } from '@tanstack/react-query';
import { getMfaStatus, sendMfaCode, setAccountPassword, verifyMfaCode } from './api';

export const mfaKeys = { status: ['mfa', 'status'] as const };

export const useMfaStatus = (enabled: boolean) =>
  useQuery({
    queryKey: mfaKeys.status,
    queryFn: ({ signal }) => getMfaStatus(signal),
    enabled,
    staleTime: Infinity,
    meta: { silent: true },
  });

export const useSendMfaCode = () => useMutation({ mutationFn: sendMfaCode, meta: { silent: true } });

export const useVerifyMfaCode = () =>
  useMutation({ mutationFn: (code: string) => verifyMfaCode(code), meta: { silent: true } });

export const useSetAccountPassword = () =>
  useMutation({ mutationFn: (password: string) => setAccountPassword(password), meta: { silent: true } });
